import { render, staticRenderFns } from "./createDesignationModal.vue?vue&type=template&id=76ec16cf&"
import script from "./createDesignationModal.vue?vue&type=script&lang=js&"
export * from "./createDesignationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports